import { Cancel, Save } from "@mui/icons-material";
import { Button } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";
import { useFormState } from "react-final-form";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: ${({ theme }) => theme.spacing(2)};
`;
interface FormButtonsProps {
    handleCancelClick: () => void;
}

const FormButtons: FC<PropsWithChildren<FormButtonsProps>> = ({ handleCancelClick }) => {
    const { pristine, hasValidationErrors, submitting } = useFormState();

    return (
        <Wrapper>
            <Button startIcon={<Cancel />} variant="text" onClick={handleCancelClick}>
                <FormattedMessage id="reviermanager.button.cancel" defaultMessage="Abbrechen" />
            </Button>
            <Button color="primary" variant="contained" type="submit" startIcon={<Save />} disabled={pristine || hasValidationErrors || submitting}>
                <FormattedMessage id="reviermanager.button.save" defaultMessage="Speichern" />
            </Button>
        </Wrapper>
    );
};

export default FormButtons;
